export default __webpack_public_path__ + "images/QN.f758c11.png";